/**
 * UUIDv7 (RFC 9562): 48-bit Unix ms timestamp, version 7, 74 random bits. Client-generated
 * project ids from day one so guest projects never collide when they are later synced.
 */
export function uuidv7(
  now: number = Date.now(),
  random: (bytes: Uint8Array<ArrayBuffer>) => void = fillRandom,
): string {
  const b = new Uint8Array(16);
  random(b);
  const ts = Math.max(0, Math.floor(now));
  // 48-bit big-endian timestamp (split to stay within 32-bit bitwise math).
  const hi = Math.floor(ts / 2 ** 16);
  const lo = ts % 2 ** 16;
  b[0] = (hi >>> 24) & 0xff;
  b[1] = (hi >>> 16) & 0xff;
  b[2] = (hi >>> 8) & 0xff;
  b[3] = hi & 0xff;
  b[4] = (lo >>> 8) & 0xff;
  b[5] = lo & 0xff;
  b[6] = (b[6] & 0x0f) | 0x70; // version 7
  b[8] = (b[8] & 0x3f) | 0x80; // variant 10
  const h = Array.from(b, (x) => x.toString(16).padStart(2, '0')).join('');
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}

function fillRandom(bytes: Uint8Array<ArrayBuffer>): void {
  crypto.getRandomValues(bytes);
}

const UUID_V7 = /^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;
export function isUuidV7(id: string): boolean {
  return UUID_V7.test(id);
}

/** Timestamp (ms) encoded in a UUIDv7. */
export function uuidv7Time(id: string): number {
  const hex = id.replace(/-/g, '').slice(0, 12);
  return Number.parseInt(hex, 16);
}
